import styled, { css } from 'styled-components';

export const TablePlace = styled.div`
  overflow-x: auto;
  max-width: 100%;

  &.in-client {
    /* overflow: hidden; */
    /* width: 100%; */
    /* margin-left: -1px; */
    /* margin-right: -1px; */
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    /* border-radius: 0; */
    border-left: 0;
    border-right: 0;
    border-radius: 0 0 16px 16px;
    /* border-bottom: 0; */
  }
`;

export const TableFooter = styled.div`
  padding: 15px 0;
`;

export const TableCmp = styled.table`
  /* table-layout: fixed; */
  table-layout: auto;
  border-collapse: collapse;
  width: 100%;
  text-align: left;
  th,
  td {
    min-width: 50px;
  }

  ${(props) =>
    props.$sticky &&
    css`
      padding-top: 35px;
    `}
`;

export const TableBody = styled.tbody``;
